import { Button } from '@planne-software/uni';
import { Box, styled } from '@planne-software/uni/mui/material';

export const LanguageOptionButton = styled(Button)(({ theme }) => ({
  '&[data-selected="true"]': {
    background: theme.tokens.colors['fill-color-neutral-soft'] + ` !important`,
    borderColor: theme.tokens.colors['border-color-neutral-strong'] + ` !important`,
    boxShadow: theme.tokens.ring['ring-gray-inner-shadow'] + ` !important`,
  },
}));

export const TriggerValue = styled(Box)({
  display: 'inline-flex',
  alignItems: 'center',
  gap: '4px',
  minWidth: 0,
});

export const TriggerLabel = styled('span')(({ theme }) => ({
  ...theme.tokens.typography['text-sm-semibold'],
  color: theme.tokens.colors['text-color-neutral-strongest'],
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
}));
